// src/components/Dashboard/HealthStatus.js
import React from "react";

export default function HealthStatus({ data }) {
    const healthy = data?.status === "Healthy";

    return (
        <div className="bg-white rounded-2xl p-5 shadow-md border border-orange-300 hover:shadow-orange-400/40 transition-all duration-300">
            <h2 className="text-lg font-semibold mb-3 text-orange-600">System Health</h2>
            <p className="text-sm text-gray-700">
                🧠 App Status:{" "}
                <span
                    className={`font-semibold ${healthy ? "text-green-600" : "text-red-500"
                        }`}
                >
                    {data?.status || "Unknown"}
                </span>
            </p>
            <p className="text-sm text-gray-700">
                💾 Database: <span className="text-orange-500 font-medium">{data?.db}</span>
            </p>
            <p className="text-xs text-gray-500 mt-3">{data?.time}</p>
        </div>
    );
}
